import { Box, Flex, Heading } from "@chakra-ui/react";
import { Pagination } from "components/Pagination";
import { ReactTable } from "../../components/ReactTable";

type DashboardTableProps = {
    title?:string;
    tableColumns:any;
    tableData:any;
    handleSearch:any;
    searchKey:any;
    setSearchKey:any;
    handleJumpToPage:any;
    handleSetNextPage:any;
    handleSetPrevPage:any;
    handleClearSearch?:any;
    page:any;
    pageSize:any;
    setPageSize:any;
}

export default function DashboardTable({title,page,handleJumpToPage,handleSearch, handleClearSearch,handleSetNextPage,handleSetPrevPage, tableColumns,tableData, setPageSize, pageSize, searchKey, setSearchKey}:DashboardTableProps) {
  return (
    <>
      <Flex flexDirection="column" alignItems="start" height={480}>
        <Box
          bg="white"
          w={{ md: "100%", base: "100%" }}
          borderRadius="10px"
          height={480}
          overflow={"scroll"}
        >
          <Heading p={3} fontSize={"l"}>{title}</Heading>
          {/* <Flex
            bg="white"
            justifyContent="center"
            alignItems="center"
            px="12px"
            py="16px"
            flexDirection={{ md: "row", base: "column" }}
          >
            <Flex
              flex={1}
              alignItems="center"
              alignSelf={{ md: "auto", base: "stretch" }}
              flexDirection={{ base: "column", sm: "row" }}
            >
              <InputGroup w={{ base: "100%", sm: "30%" }}>
                
                <Input
                  placeholder={`Rechercher`}
                  value={searchKey}
                  onChange={(e) => setSearchKey(e.target.value)}
                  gap="8px"
                  borderWidth="1px"
                  borderRadius="8px"
                />
                <InputRightElement>
                  {searchKey?.length > 0 ? (
                    <CloseIcon onClick={handleClearSearch} />
                  ) : null}
                </InputRightElement>
              </InputGroup>
              <IconButton
                onClick={handleSearch}
                ml={2}
                borderRadius={"10px"}
                py={"19px"}
                border={"1px solid #e2e4e6"}
                aria-label="search"
                icon={<SearchIcon />}
                justifyContent={"center"}
                alignItems={"center"}
              />
            </Flex>
            <Image
              src="images/img_dot_menu.svg"
              alt="Menu Image"
              h="24px"
              w={{ md: "24px", base: "100%" }}
            />
          </Flex> */}
          <ReactTable
            size="sm"
            headerCellProps={{ bg: "white" }}
            tableProps={{
              borderColor: "neutral.600",
              borderTopWidth: "1px",
              borderStyle: "solid",
            }}
            columns={tableColumns as any}
            data={tableData}
          />
          <Pagination
            pageIndex={page}
            pageSize={pageSize}
            setNextPageIndex={handleSetNextPage}
            setPrevPageIndex={handleSetPrevPage}
            setPageSize={setPageSize}
            jumpToPage={handleJumpToPage}
            numberOfPages={
              tableData &&
              tableData.length > 0 &&
              tableData[0].num_of_pages
            }
          />
        </Box>
      </Flex>
    </>
  );
}
